import React from 'react';

export default props => (
  <svg {...props} viewBox="0 0 80 80" fill="none">
    {props.children}
    <path
      fill="none"
      stroke="#15161a"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M35.8 38.7 13 25.4V1.6L35.8 15v23.7ZM67 64.1l-14.9-8.6V40l15 8.7v15.4Z"
    />
    <path
      fill="#F4EEE6"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m14.5 62.2 4.3 2.4-4.8 2.8-4.3-2.5 4.8-2.7Z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M20.4 65.4 30 71l-4.9 3-9.5-5.6 4.8-2.9Z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m29.9 73.9 9.8 5.8"
    />
    <path
      fill="#FAF5EF"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m57.3 17.2 13 7.5V29l-13-7.6v-4.1Z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M55.2 67.7 29.4 52.8a11.2 11.2 0 0 0-10 0c-2.9 1.6-2.9 4.2 0 5.8l25.8 15c2.7 1.5 7.2 1.5 10 0 2.8-1.7 2.8-4.3 0-5.9Z"
    />
    <path fill="#fefdfc" d="M57 31.6v39.9l-2.6 2.4-4.8.8-3.7-.9L18 57.5l-1-1.3V17l14.2-.5L57 31.6Z" />
    <path
      fill="#F4EEE6"
      d="M37.7 44.5c0-2.1-1.4-4.7-3.2-5.7-1.8-1-3.3-.2-3.3 1.9 0 1.6 1 3.6 2.2 4.8V53l2 1.1v-7.3c1.3.4 2.3-.5 2.3-2.2Z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M35.6 45.3c0-2-1.4-4.6-3.2-5.7s-3.3-.2-3.3 2c0 1.6.9 3.5 2.2 4.8v7.3l2 1.2v-7.3c1.3.3 2.3-.6 2.3-2.3Z"
    />
    <path
      fill="#F4EEE6"
      d="m48.1 37 .5 32c0 .7-.3 1.3-.7 1.8-.6.8-1.7 1.2-2.7 1-2.5-.5-5.7-1.5-7.9-2.7l8.3 4.8 2.3.7 2.6.3 5-1.5 1.5-1.6.3-.9V34l-1 1.6L53 37l-2.9.3-2-.3Z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="m55.2 30.3-25.8-15c-2.8-1.5-7.3-1.5-10 0s-2.9 4.3 0 5.9L45.1 36c2.7 1.5 7.2 1.5 10 0s2.8-4.3 0-5.9Zm-38-11.9v37.8m40.1 14.7c-.1 1-.8 1.9-2 2.6a11.2 11.2 0 0 1-10.1 0L19.3 58.6c-1.3-.7-2-1.7-2-2.7"
    />
    <path
      fill="#fff"
      d="M31.8 19c0 1-1.4 1.8-3.2 1.8s-3.1-.9-3.1-1.9v-9c0-4 1.5-7 4.2-8.6 2.7-1.6 6.2-1.4 9.6.6 6 3.5 10.6 11.6 10.6 18.5v9c0 1-1.4 1.9-3.1 1.9s-3.2-.9-3.2-1.9v-9c0-4.7-3.4-10.6-7.5-13-1.3-.8-2.5-1-3.2-.6-.7.4-1 1.6-1 3.1v9Z"
    />
    <path fill="none" stroke="#000" strokeLinejoin="round" strokeWidth={0.5} d="M57.3 33.5v37.2" />
    <path
      fill="#fefdfc"
      d="m47.7 14 .1-.2c-1.7-4.7-5-9-8.8-11.3-3.2-1.8-6.4-2-9-.6-2.4 1.5-3.8 4.5-3.8 8.3v1.5S27 6 32 4.3c4.8-1.7 8.5 3 10.4 6.2 2 3.1 3.5 4.4 5.3 3.4Z"
    />
    <path
      fill="#F4EEE6"
      d="M29 11.7c0-1 .2-2 .7-2.8C30.2 8 31 7.4 32 7l1.3-.4-1 1.2-.4 1.7v10l-1.1.9-1.7.4v-9.1Zm18.1 19.4V20.5a4.9 4.9 0 0 1 2.3-4l.5 2v11.3l-.8 1-2 .4Z"
    />
    <path
      fill="none"
      stroke="#000"
      strokeMiterlimit={10}
      strokeWidth={0.5}
      d="M50 20.4v9M31.8 19c0 1-1.4 1.8-3.2 1.8s-3.1-.9-3.1-1.9v-9c0-4 1.5-7 4.2-8.6 2.7-1.6 6.2-1.4 9.6.6 6 3.5 10.6 11.6 10.6 18.5v9c0 1-1.4 1.9-3.1 1.9s-3.2-.9-3.2-1.9v-9c0-4.7-3.4-10.6-7.5-13-1.3-.8-2.5-1-3.2-.6-.7.4-1 1.6-1 3.1v9Z"
    />
  </svg>
);
